import { EndClientReportDataSourceProvider } from '../../../models/end-client-reporting-package';
import { DataDownloadFile, DataDownloadFormat, DataExport } from './data-export';
import { decipherCsvDownload } from './decipher-csv';
import { decipherExcelDownload } from './decipher-excel';
import { decipherSpssDownload } from './decipher-spss';

export interface DataDownloadOption {
  format: DataDownloadFormat;
  label: string;
  detail: string;
  icon: string;
  build: (data: DataExport, reportName: string) => Promise<DataDownloadFile>;
}

/**
 * What a report's data can be downloaded as, by whose data it is. Each provider gets its own
 * platform's file shapes, so a download reads like one from that platform and goes back in through
 * the matching upload (END_CLIENT_REPORT_UPLOAD_FORMATS). Adding a provider or a format means adding
 * its exporter here; anything not listed simply isn't offered.
 */
export const END_CLIENT_REPORT_DATA_DOWNLOADS: Record<EndClientReportDataSourceProvider, DataDownloadOption[]> = {
  [EndClientReportDataSourceProvider.Decipher]: [
    { format: 'csv', label: 'CSV', detail: 'Zipped with its datamap.txt', icon: 'fa-file-csv', build: decipherCsvDownload },
    { format: 'xlsx', label: 'Excel', detail: 'With a Datamap tab', icon: 'fa-file-excel', build: decipherExcelDownload },
    { format: 'sav', label: 'SPSS', detail: 'With variable and value labels', icon: 'fa-file-lines', build: decipherSpssDownload },
  ],
};

/** None where the source has no provider recorded: nothing says which shapes to write. */
export function dataDownloadsFor(provider: EndClientReportDataSourceProvider | null | undefined): DataDownloadOption[] {
  return provider === null || provider === undefined ? [] : END_CLIENT_REPORT_DATA_DOWNLOADS[provider] ?? [];
}
